export const KENTIK_POLICY_DEFINITIONS = [
  'DEFINE tenancy KentikTenancy as "{{kentikTenancyId}}"',
  'DEFINE group KentikMetadataGroup as "{{kentikUserGroup}}"'
];

export const TAB_ID_CUSTOM_USER = 'custom_user';
export const TAB_ID_CROSS_TENENCY_POLICY = 'cross_tenancy_policy';

const METADATA_POLICY_DEFINITIONS = [
  "TO INSPECT tenancies in tenancy where all {request.permission='TENANCY_INSPECT', request.operation='ListRegionSubscriptions'}",
  'TO READ compartments IN tenancy',
  'TO READ virtual-network-family IN tenancy',
  'TO INSPECT volume-family IN tenancy',
  'TO INSPECT instance-family in tenancy',
  'TO READ cluster-family IN tenancy',
  'TO INSPECT log-groups IN tenancy',
  'TO INSPECT network-firewall-family IN tenancy'
];

const FLOWS_POLICY_DEFINITIONS = ['TO READ object-family IN tenancy'];
const METRICS_POLICY_DEFINITIONS = ['TO READ metrics IN tenancy'];

const ADMIT_PREFIX = 'ADMIT group KentikMetadataGroup of tenancy KentikTenancy';
const ALLOW_PREFIX = 'ALLOW group <CustomerCreatedKentikGroup>';

const generatePolicyStatements = (crossTenancy = false, statements = []) => {
  if (crossTenancy) {
    return statements.map((statement) => `${ADMIT_PREFIX} ${statement}`);
  }

  return statements.map((statement) => `${ALLOW_PREFIX} ${statement}`);
};

export function generatePolicy(options = { crossTenancy: false, includeFlowLogs: false, includeMetrics: false }) {
  const { crossTenancy = false, includeFlowLogs = false, includeMetrics = false } = options;

  const result = [];

  if (crossTenancy) {
    result.push(...KENTIK_POLICY_DEFINITIONS);
  }

  result.push(...generatePolicyStatements(crossTenancy, METADATA_POLICY_DEFINITIONS));

  if (includeFlowLogs) {
    result.push(...generatePolicyStatements(crossTenancy, FLOWS_POLICY_DEFINITIONS));
  }

  if (includeMetrics) {
    result.push(...generatePolicyStatements(crossTenancy, METRICS_POLICY_DEFINITIONS));
  }
  return result;
}
